import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import routes from './routes.json';
import Home from './pages/Home';
import About from './pages/About';
import ParentCoordinator from './pages/ParentCoordinator';
import Calendar from './pages/Calendar';
import Contact from './pages/Contact';
import MissionStatement from './pages/MissionStatement';
import SurveyResults from './pages/SurveyResults';
import Gallery from './pages/Gallery';
import MeetTheStaff from './pages/MeetTheStaff';
import ComingSoon from './pages/ComingSoon';

// Maps the `component` string in src/routes.json to the imported page component.
// To ADD a page: create the component, import it above, add it to this registry,
// and add a { path, component, title } entry to src/routes.json.
// To REMOVE a page: delete the component file, its import, its registry entry,
// and its routes.json entry. routes.json is the single source of truth shared by
// this router and scripts/prerender.mjs.
const registry = {
  Home,
  About,
  ParentCoordinator,
  Calendar,
  Contact,
  MissionStatement,
  SurveyResults,
  Gallery,
  MeetTheStaff,
  ComingSoon,
};

// ScrollToTop component to handle automatic scrolling on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Routes>
          {/* Routes are rendered from src/routes.json (single source of truth,
              shared with scripts/prerender.mjs). See the `registry` comment above. */}
          {routes.map(({ path, component }) => {
            const C = registry[component];
            return C ? <Route key={path} path={path} element={<C />} /> : null;
          })}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
